import { useState, useEffect } from 'react';
import { useLazyFetchExamQuery } from '../service';

export const useFetchExam = () => {
	const [activeExam, setActiveExam] = useState(null);
	const [triggerFetchExam, { data, isSuccess, error, isLoading }] = useLazyFetchExamQuery();

	// New states for countdown
	const [countdown, setCountdown] = useState(null); // Remaining time in seconds
	const [lastCountdownValue, setLastCountdownValue] = useState(null); // Store the last countdown value
	const [durationInSeconds, setDurationInSeconds] = useState(null);
	const [displayTimesUp, setDisplayTimesUp] = useState(false);

	const fetchExam = async (id, questionIds, subject) => {
		const durationInMinutes = activeExam?.duration || 30; // Assuming exam duration is in minutes
		const durationInSeconds = durationInMinutes * 60;
		setCountdown(durationInSeconds);
		setDurationInSeconds(durationInSeconds);

		await triggerFetchExam({ id, questionIds, subject });
	};

	// Countdown logic
	useEffect(() => {
		if (countdown === null) return; // Stop countdown if the exam is finished

		if (countdown <= 0) {
			handleTimeExpiry();
			return;
		}

		const interval = setInterval(() => {
			setCountdown((prev) => (prev > 0 ? prev - 1 : 0));
		}, 1000);

		return () => clearInterval(interval);
	}, [countdown]);

	const handleTimeExpiry = () => {
		setCountdown(null);
		setDisplayTimesUp(true);
	};

	const stopTimer = () => {
		setLastCountdownValue(countdown); // Save the last countdown value before stopping
		setCountdown(null); // Stop the countdown
	};

	// Reset states when exam is finished
	const finishExam = () => {
		stopTimer();
	};

	useEffect(() => {
		if (data) {
			setActiveExam({
				answers: [],
				data: data,
				currentAnswer: null,
				activeQuestion: data.Questions[0],
				questionNumber: 0
			});
		}
	}, [data]);

	return {
		activeExam,
		setActiveExam,
		countdown,
		displayTimesUp,
		setDisplayTimesUp,
		setCountdown,
		lastCountdownValue,
		durationInSeconds,
		setDurationInSeconds,
		stopTimer,
		finishExam,
		fetchExam,
		error,
		isLoading
	};
};
